// Keep the bannerless RCPO collection aligned to complete three-card rows.
(function () {
  var rcpoPath = "/collections/rolex-certified-pre-owned-watches";
  if (window.location.pathname.replace(/\/$/, "") !== rcpoPath) return;

  function withoutLimitParam(value) {
    if (value == null) return value;

    var url;
    try {
      url = new URL(String(value), window.location.href);
    } catch (error) {
      return value;
    }

    if (
      url.origin !== window.location.origin ||
      url.pathname.replace(/\/$/, "") !== rcpoPath ||
      !url.searchParams.has("limit")
    ) {
      return value;
    }

    url.searchParams.delete("limit");
    return url.pathname + url.search + url.hash;
  }

  ["pushState", "replaceState"].forEach(function (method) {
    var original = window.history[method];

    window.history[method] = function (state, title, url) {
      return original.call(this, state, title, withoutLimitParam(url));
    };
  });

  window.history.replaceState(
    window.history.state,
    "",
    withoutLimitParam(window.location.href)
  );

  var limitApplied = false;

  function syncProductLimit() {
    var limitSelect = document.querySelector("#setLimit");

    if (
      limitApplied ||
      !limitSelect ||
      typeof window.setLimit !== "function"
    ) {
      return;
    }

    limitApplied = true;
    limitSelect.value = "12";
    window.setLimit("12");
  }

  document.addEventListener("DOMContentLoaded", function () {
    syncProductLimit();
    window.setTimeout(syncProductLimit, 750);
  }, { once: true });

  window.addEventListener("globoFilterRenderCompleted", syncProductLimit);
  document.addEventListener("gf:updated", syncProductLimit);
})();

  document.addEventListener("click", function (event) {
    if (event.target.matches(".toggle-collection")) {
      const parent = event.target.closest(".view-collection");
      if (parent) {
        parent.classList.toggle("open");
        const isOpen = parent.classList.contains("open");
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
      // Initialize the sliders for Feature Product and Keep Exploring
      const sliders = [
          { selector: '#feature-product-slider', perPage: 4 },
          { selector: '#related-products-slider', perPage: 3 },
          { selector: '#keep-exploring-slider', perPage: 4 }
      ];

      sliders.forEach(sliderConfig => {
          const element = document.querySelector(sliderConfig.selector);
          if (element) {
              new Splide(sliderConfig.selector, {
                  type: 'slide',
                  perPage: sliderConfig.perPage,
                  pagination: true,
                  arrows: true,
                  gap: '8px',
                  breakpoints: {
                      1023: { perPage: 3 },
                      767: { perPage: 2 }
                  }
              }).mount();
          }
      });
  });

// rolex CPO menu toggle script
document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(".cpo-menu-button");
  const mobileMenu = document.querySelector(".cpo-navigation-mobile-wrapper");
  const toggle_icon = document.querySelector(".cpo-menu-button");
  if (!toggleButton) return;
  if (!mobileMenu) return;
  if (!toggle_icon) return;

  toggleButton.addEventListener("click", function (e) {
    e.preventDefault();
    if (mobileMenu.hasAttribute("active")) {
      // Hide menu
      mobileMenu.removeAttribute("active");
      toggle_icon.removeAttribute("active");
       } else {
      // Show menu
      mobileMenu.setAttribute("active", "");
      toggle_icon.setAttribute("active", "");
       }
  });
});

// Rolex Preowned Banner Slider
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rolex-preowned-banner-slider').forEach(slider => {
    const showArrows = slider.dataset.showArrows === 'true';
    const showPagination = slider.dataset.showPagination === 'true';

    new Splide(slider, {
      type: 'slide',
      perPage: 1,
      arrows: showArrows,
      pagination: showPagination,
      autoplay: false,
      interval: 5000,
      pauseOnHover: true,
    }).mount();
  });
});

document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('rolex-preowned-gallery')) return;

    // Initialize the product gallery once the document is ready
    initializeProductGallery();
    initialize360Viewer();
});

function initializeProductGallery() {
    const openSliderButton = document.getElementById('openSliderButton');
    const sliderPopup = document.getElementById('sliderPopup');
    const closeSliderButton = document.getElementById('closeSliderButton');

    // Ensure required elements are present
    if (!sliderPopup || !closeSliderButton) {
        console.warn('Product gallery popup elements not found.');
        return;
    }

    initMainGallery();
    init360ImageSlider();
    bindPopupEvents(openSliderButton, sliderPopup, closeSliderButton);
}

function initMainGallery() {
    const gallery = new Splide('#rolex-preowned-gallery', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: true,
        autoplay: false,
    });

    const thumbs = new Splide('#rolex-preowned-gallery-thumbs', {
        perPage: 4,
        isNavigation: true,
        gap: 8,
        focus: 'center',
        pagination: false,
        arrows: false,
        speed: 50
    });

    thumbs.on('mounted', function () {
        thumbs.Components.Elements.slides.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                gallery.go(index + 1);
                thumb.classList.add('is-active');
            });
        });
    });

    gallery.on('move', function (index) {
        const thumbIndex = index - 1;
        if (thumbIndex >= 0 && thumbIndex < thumbs.length) {
            thumbs.go(thumbIndex);
        } else {
            thumbs.Components.Elements.slides.forEach(slide => {
                slide.classList.remove('is-active');
            });
        }
    });

    let run = 0;
    thumbs.on('active', function (index) {
        if (run <= 1) {
            thumbs.Components.Elements.slides.forEach(slide => {
                slide.classList.remove('is-active');
            });
        }
        run++;
    });

    gallery.mount();
    thumbs.mount();
}

function init360ImageSlider() {
    new Splide('#rolex-preowned-gallery360', {
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: true,
        autoplay: false,
        drag: false,
    }).mount();
}

function bindPopupEvents(openButton, popup, closeButton) {
    openButton.addEventListener('click', function () {
        popup.style.display = 'grid'; // Show the popup
    });

    closeButton.addEventListener('click', function () {
        popup.style.display = 'none'; // Hide the popup
    });
}

function initialize360Viewer() {
    const viewer = document.querySelector('.gallery360__viewer');
    if (!viewer) {
        console.warn('360 viewer element not found.');
        return;
    }

    const images = viewer.querySelectorAll('img');
    if (images.length === 0) {
        console.warn('No images found for 360 viewer.');
        return;
    }

    let frame = 0;
    const totalImages = images.length;
    const threshold = 45;

    // Promote lazy data-src -> src so all frames load together for a smooth spin
    images.forEach((image) => {
        if (image.dataset.src && !image.src) {
            image.src = image.dataset.src;
        }
    });

    // Activate the first image
    updateActiveImage(images, frame);

    // Impetus for left-right drag interaction
    new Impetus({
        source: viewer,
        multiplier: 1.5,
        friction: 0.85,
        boundY: [0, 0], // Prevent vertical movement
        update: (x) => {
            const newFrame = calculateFrame(x, threshold, totalImages);
            if (newFrame !== frame) {
                updateActiveImage(images, newFrame);
                frame = newFrame;
            }
        },
    });
}

function updateActiveImage(images, frame) {
    images.forEach((image) => image.classList.remove('active'));
    images[frame].classList.add('active');
}

function calculateFrame(x, threshold, totalImages) {
    let frame = Math.floor(-x / threshold) % totalImages;
    return frame < 0 ? totalImages + frame : frame;
}


document.addEventListener("DOMContentLoaded", function () {

  function rolexPreownedAccordionInit() {
    // scope only this section
    const accordions = document.querySelectorAll(
      ".rolex-preowned_accordion .rolex-preowned_accordion-item"
    );

    if (!accordions.length) return false;

    function updateHeight(content) {
      if (!content) return;
      requestAnimationFrame(() => {
        content.style.maxHeight = content.scrollHeight + "px";
      });
    }

    accordions.forEach(function (item, index) {
      const header = item.querySelector(".accordion-header");
      const content = item.querySelector(".rolex-preowned_accordion-content");

      if (!header || !content) {
        console.warn("[Shopify Accordion] Missing header/content", item);
        return;
      }

      // accessibility
      header.setAttribute("aria-expanded", "false");

      // Default open first
      if (index === 0) {
        item.classList.add("open");
        header.setAttribute("aria-expanded", "true");
        updateHeight(content);
      } else {
        content.style.maxHeight = "0px";
      }

      function openAccordion() {
        item.classList.add("open");
        header.setAttribute("aria-expanded", "true");
        updateHeight(content);
      }

      function closeAccordion() {
        item.classList.remove("open");
        header.setAttribute("aria-expanded", "false");
        content.style.maxHeight = "0px";
      }

      // Toggle click
      header.addEventListener("click", function () {
        if (item.classList.contains("open")) {
          closeAccordion();
        } else {
          openAccordion();
        }
      });

      // MutationObserver (dynamic form / success / steps)
      const observer = new MutationObserver(function () {
        if (item.classList.contains("open")) {
          updateHeight(content);
        }
      });

      observer.observe(content, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class", "data-step"]
      });

      // Image load fix
      const imgs = content.querySelectorAll("img");
      imgs.forEach((img) => {
        if (!img.complete) {
          img.addEventListener("load", () => {
            if (item.classList.contains("open")) {
              updateHeight(content);
            }
          });
        }
      });
    });

    // Window load safety
    window.addEventListener("load", function () {
      accordions.forEach((item) => {
        if (item.classList.contains("open")) {
          const content = item.querySelector(".rolex-preowned_accordion-content");
          if (content) {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        }
      });
    });

    return true;
  }

  rolexPreownedAccordionInit();
});

// Showroom dropdown (call section): tap-to-toggle so it also closes on a
// second tap, not only when tapping elsewhere - desktop keeps the existing
// hover-to-open behaviour, this just adds click support on top of it.
(function () {
  document.addEventListener("click", function (event) {
    var trigger = event.target.closest(".cpo-contact-number > a");
    var openItem = document.querySelector(".cpo-contact-number.is-open");

    if (trigger) {
      event.preventDefault();
      var item = trigger.closest(".cpo-contact-number");
      var isOpen = item.classList.contains("is-open");

      if (openItem && openItem !== item) {
        openItem.classList.remove("is-open");
      }

      item.classList.toggle("is-open", !isOpen);
      return;
    }

    if (openItem && !event.target.closest(".cpo-contact-number")) {
      openItem.classList.remove("is-open");
    }
  });
})();
